import type { PageWithLayout, PageProps, ICategoryListInput } from "@types";
import type { Meta } from "@layouts/page";
import type { GetServerSideProps } from "next";

import Page from "@layouts/page";
import { useTranslations } from "use-intl";
import { getCookie, setContext } from "@utils/Cookies";
import { getLayout as getDefaultLayout } from "@layouts/default-layout";
import ProductApi from "@api/productApi";
import { hasArea } from "@utils/checkDependencies";
import Categories from "@templates/categories";
import { authApi } from "gate";
import { COOKIE_ACCESS_TOKEN_KEY } from "@utils/constants";
import { checkIfMaintenanceNeededOrFail } from "@utils/api";

interface Props extends PageProps {
  data?: ICategoryListInput;
}

const CategoriesPage: PageWithLayout<Props> = ({ data, appFallback }) => {
  const t = useTranslations("");

  const meta: Meta = {
    title: t("client_general_categories"),
    description: appFallback?.website.description || "Dabdoob",
    keywords: appFallback?.website.keywords,
  };
  return (
    <Page meta={meta}>
      <Categories data={data?.items || []} />
    </Page>
  );
};

CategoriesPage.translationFile = "translation";
CategoriesPage.getLayout = (page, props) => getDefaultLayout(page, { ...props }, {});

export const getServerSideProps: GetServerSideProps<Props> = async (ctx) => {
  setContext(ctx);
  const Cookies = getCookie();

  if (!Cookies.get(COOKIE_ACCESS_TOKEN_KEY)) {
    await authApi
      .deviceAuth()
      .fetch()
      .then((res) => {
        const token = res.data.access_token || "";
        Cookies.set(COOKIE_ACCESS_TOKEN_KEY, token, {}, 365 * 2);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  if (hasArea()) {
    try {
      const data = await ProductApi.categoryList().fetch();
      return {
        props: {
          data: data.data,
        },
      };
    } catch (error) {
      return checkIfMaintenanceNeededOrFail(error);
    }
  } else {
    return {
      props: {},
    };
  }
};

export default CategoriesPage;
